import { render, staticRenderFns } from "./xstjList.vue?vue&type=template&id=775620b8&"
import script from "./xstjList.vue?vue&type=script&lang=js&"
export * from "./xstjList.vue?vue&type=script&lang=js&"
import style0 from "./xstjList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "xstjList.vue"
export default component.exports